import { ResponseWrapper, PagedResults, trackerGet, trackerPatch, decodeResult } from "./basicApi.ts";
import { SampleGetParametersByNameDto } from "./sample.ts";

interface EsafDto {
  id: number;
  slug: string;
  name: string;
  description?: string;
  slug_beamline: string;
  slug_proposal: string;
  date_earliest_start?: string;
  date_latest_end?: string;
  ids_owners: number[];
  ids_editors: number[];
  ids_watchers: number[];
  archived: boolean;
  date_record_created: string;
}


interface EsafUpdateDto {
  slug: string;
  name?: string;
  description?: string;
  ids_owners?: number[];
  ids_editors?: number[];
  ids_watchers?: number[];
  archived?: boolean;
}


// Get a list of ESAFs the logged-in user has access to
async function getEsafs(): Promise<ResponseWrapper<PagedResults<EsafDto>>> {
  const result = await trackerGet(`esafs/`, {});
  return decodeResult(result);
}


// Get all Parameter values in name/value dictionaries for all Samples for the given ESAF
async function getEsafParameterValues(slug: string): Promise<ResponseWrapper<SampleGetParametersByNameDto[]>> {
  const result = await trackerGet(`esafs/${slug}/parameter_values/`, {});
  return decodeResult(result);
}


// Update an ESAF record on the server.
async function updateEsaf(dto: EsafUpdateDto): Promise<ResponseWrapper<EsafDto>> {
  const result = await trackerPatch(`esafs/${dto.slug}/`, JSON.stringify(dto));
  if (result.success) {
   const body:any = await result.response!.json();
   return { success: true, response: body };
 }
 return { success: false, message: result.message };
}


export type { EsafDto, EsafUpdateDto };
export { getEsafs, getEsafParameterValues, updateEsaf }
